import { Stage } from '@eventbrite/webapp-constants';

export const CORE_HOSTS = {
    [Stage.LOCAL]: 'localhost',
    [Stage.DEV]: 'evbdev.com',
    [Stage.TEST]: 'evbqa.com',
    [Stage.PROD]: 'eventbrite.com',
};

export const APPLICATION_BASE_PATH = '/home';
